export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "ASSET_NAME_PLACEHOLDER": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enter name"])},
        "SUGGESTED_ASSETS_LABEL": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suggested assets"])},
        "ASSETS_FOUND": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Found for \"", _interpolate(_named("text")), "\""])},
        "RECENTLY_SUBMITTED": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Recently submitted from"])},
        "IN_BRIEFS": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["in ", _interpolate(_named("briefs"))])},
        "IN_THIS_BRIEF": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Already evaluated in this ", _interpolate(_named("brief"))])},
        "FROM_DIRECTORY": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Found in ", _interpolate(_named("database"))])},
        "SEARCH_ASSET_HINT": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Start typing to see recommendations from existing assets"])},
        "NEW_ASSET_HINT": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select to create"])},
        "ASSET_NAME_VALIDATION": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Asset name is mandatory."])}
      }
    }
  })
}
